import { MsalProvider } from "@azure/msal-react";
import {
  PublicClientApplication,
  EventType,
  EventMessage,
  AccountInfo,
} from "@azure/msal-browser";
import { msalConfig } from "../config/authConfig";
import React from "react";

// Initialize MSAL
export const msalInstance = new PublicClientApplication(msalConfig);
// Set active account if already signed in
const accounts = msalInstance.getAllAccounts();
if (accounts.length > 0) {
  msalInstance.setActiveAccount(accounts[0]);
}

// Listen for sign-in event and set active account
msalInstance.addEventCallback((event: EventMessage) => {
  if (
    event.eventType === EventType.LOGIN_SUCCESS &&
    event.payload &&
    "account" in event.payload
  ) {
    const account = event.payload.account as AccountInfo;
    msalInstance.setActiveAccount(account);
  }
});

interface AuthProviderProps {
  children: React.ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  return <MsalProvider instance={msalInstance}>{children}</MsalProvider>;
};
